import { getActionTypes } from './get-actions';

export const getReducer = (actionPrefix) => (action) => ({
  [getActionTypes(actionPrefix).SHOW_BANNER_BOTTOM]: () => ({
    showBanner: true,
  }),
  [getActionTypes(actionPrefix).HIDE_BANNER_BOTTOM]: () => ({
    showBanner: false,
  }),
});
